/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import { connect } from 'react-redux'
import { string, func, shape } from 'prop-types'
import Icon from 'common/components/icon'

export const SubMenuHamBurger = ({ linkName, dispatch, ui }) => (
  <li className={`sub-menu custom-link ${ui.subMenuOpen ? 'active' : ''}`}>
    <a
      aria-label="main menu"
      className="sub-nav"
      id="nav-toggle"
      onClick={() => dispatch({ type: 'TOGGLE_SUBMENU' })}
    >
      <Icon name="menu" size="medium" />
      <span className="submenu-hamburger-label">{linkName || 'Menu'}</span>
    </a>
  </li>
)

SubMenuHamBurger.propTypes = {
  linkName: string.isRequired,
  dispatch: func.isRequired,
  ui: shape({}).isRequired,
}

export default connect()(SubMenuHamBurger)



// WEBPACK FOOTER //
// ./components/secondary-nav/SubMenuHamBurger.js